import { graphql } from '@apollo/react-hoc';

import Persons from './Persons.graphql';
import Person from './Person.graphql';
import CreatePerson from './CreatePerson.graphql';
import UpdatePerson from './UpdatePerson.graphql';
import DeletePerson from './DeletePerson.graphql';

export const PersonsQuery = Persons;
export const PersonQuery = Person;
export const CreatePersonMutation = CreatePerson;
export const UpdatePersonMutation = UpdatePerson;
export const DeletePersonMutation = DeletePerson;

const withPersonRead = graphql(PersonQuery, {
  options: ({ id, personsPermissions }) => ({
    variables: {
      id,
      personsSeeSensitiveData: Boolean(personsPermissions?.seeSensitiveData),
    },
  }),
  props: ({ data: { person, loading } }) => ({ person, loading }),
});

const withPersonCreate = graphql(CreatePersonMutation, { name: 'create' });
const withPersonUpdate = graphql(UpdatePersonMutation, { name: 'update' });
const withPersonDelete = graphql(DeletePersonMutation, { name: 'remove' });

export { withPersonCreate, withPersonRead, withPersonUpdate, withPersonDelete };
